<article class="legal-page" aria-labelledby="legal-notice-title">
  <header class="legal-header">
    <h1 id="legal-notice-title">Aviso legal</h1>
    <p class="legal-intro">Este documento regula el acceso y uso del sitio web de ATSIestudio.</p>
  </header>

  <nav class="legal-index" aria-label="Contenido del aviso legal">
    <h2>Contenido</h2>
    <ol>
      <li><a href="#titular">Identificación del titular</a></li>
      <li><a href="#condiciones">Condiciones de uso</a></li>
      <li><a href="#propiedad">Propiedad intelectual</a></li>
      <li><a href="#responsabilidad">Responsabilidad y enlaces</a></li>
      <li><a href="#legislacion">Legislación aplicable</a></li>
    </ol>
  </nav>

  <section id="titular" aria-labelledby="titular-title">
    <h2 id="titular-title">1. Identificación del titular</h2>
    <dl class="legal-data">
      <div>
        <dt>Nombre comercial</dt>
        <dd>ATSIestudio</dd>
      </div>
      <div>
        <dt>Correo electrónico</dt>
        <dd><a href="mailto:contacto@atsiestudio.com">contacto@atsiestudio.com</a></dd>
      </div>
      <div>
        <dt>Teléfono</dt>
        <dd><a href="tel:+34655340607">655 340 607</a></dd>
      </div>
      <div>
        <dt>Dominio</dt>
        <dd>atsiestudio.com</dd>
      </div>
    </dl>
  </section>

  <section id="condiciones" aria-labelledby="conditions-title">
    <h2 id="conditions-title">2. Condiciones de acceso y uso</h2>
    <p>
      El acceso al sitio es gratuito, salvo el coste de conexión de la red utilizada por cada
      persona. Quien lo utilice se compromete a hacerlo de forma lícita, respetando estas
      condiciones, los derechos de terceros y la normativa aplicable.
    </p>
    <p>
      La información sobre servicios tiene carácter general y no constituye por sí sola una oferta
      contractual. El alcance, precio, calendario y condiciones de cada proyecto se concretarán en
      una propuesta aceptada por las partes.
    </p>
  </section>

  <section id="propiedad" aria-labelledby="property-title">
    <h2 id="property-title">3. Propiedad intelectual e industrial</h2>
    <p>
      Salvo que se indique lo contrario, los contenidos propios de esta web —incluidos textos,
      diseño, código, identidad gráfica y recursos visuales— pertenecen a su titular o se utilizan
      con la autorización correspondiente. No se autoriza su reproducción, distribución,
      transformación o explotación fuera de los límites permitidos por la ley sin autorización
      previa.
    </p>
    <p>Las marcas y contenidos de terceros pertenecen a sus respectivos titulares.</p>
  </section>

  <section id="responsabilidad" aria-labelledby="liability-title">
    <h2 id="liability-title">4. Disponibilidad, responsabilidad y enlaces</h2>
    <p>
      Se procura mantener la información actualizada y el sitio disponible y seguro. No obstante, no
      puede garantizarse la ausencia absoluta de errores, interrupciones o elementos dañinos. Las
      incidencias se atenderán dentro de medios razonables cuando se tenga conocimiento de ellas.
    </p>
    <p>
      Los enlaces externos se ofrecen para ampliar información o prestar una funcionalidad concreta.
      ATSIestudio no controla de forma permanente sus contenidos ni sus cambios posteriores. La
      inclusión de un enlace no implica aprobación de toda la información del sitio enlazado.
    </p>
  </section>

  <section id="legislacion" aria-labelledby="law-title">
    <h2 id="law-title">5. Legislación aplicable</h2>
    <p>
      Este aviso se interpreta conforme a la legislación española. Cualquier controversia se
      someterá a los juzgados y tribunales que resulten competentes según la normativa aplicable,
      respetando los derechos que correspondan a consumidores y usuarios cuando proceda.
    </p>
  </section>

  <footer class="legal-update">
    <p><strong>Última actualización:</strong> 17 de julio de 2026.</p>
  </footer>
</article>
